import ScrollItem from './ScrollItem';
import './Utility.css';
import './Glitch.css';
import SectionDecoration from './SectionDecoration';

import RoadmapH2Webp from '../img/RoadMap-h2.webp';
import RoadmapH2 from '../img/RoadMap-h2.png';
import RoadMapIconAvatarWebp from '../img/RoadMap-icon-avatar.webp';
import RoadMapIconAvatar from '../img/RoadMap-icon-avatar.png';
import RoadMapIconAccessWebp from '../img/RoadMap-icon-access.webp';
import RoadMapIconAccess from '../img/RoadMap-icon-access.png';
import RoadMapIconMetaverseWebp from '../img/RoadMap-icon-metaverse.webp';
import RoadMapIconMetaverse from '../img/RoadMap-icon-metaverse.png';
import RoadMapIconCollabsWebp from '../img/RoadMap-icon-collabs.webp';
import RoadMapIconCollabs from '../img/RoadMap-icon-collabs.png';
import RoadMapIconStakingWebp from '../img/RoadMap-icon-staking.webp';
import RoadMapIconStaking from '../img/RoadMap-icon-staking.png';
import RoadmapRevvingImgWebp from '../img/Roadmap-revvingImg.webp';
import RoadmapRevvingImg from '../img/Roadmap-revvingImg.png';
import YAOWebp from '../img/YAO.webp';
import YAO from '../img/YAO.png';
import YAOImageWebp from '../img/AID100.webp';
import YAOImage from '../img/AID100.png';
import AKLOWebp from '../img/Member-icon/AKLO.webp';
import AKLO from '../img/Member-icon/AKLO.png';
import TRILLWebp from '../img/Member-icon/TRILL.webp';
import TRILL from '../img/Member-icon/TRILL.png';

export default function Utility() {
    return (
        <section className="Utility" id="roadmap">
            <div className="Utility__inner">
                {/* glitch background */}
                <div className="glitch">
                    <div className="glitch__img img__05"></div>
                    <div className="glitch__img img__05"></div>
                    <div className="glitch__img img__05"></div>
                    <div className="glitch__img img__05"></div>
                    <div className="glitch__img img__05"></div>
                </div>

                {/* h2 */}
                <h2 className="Utility__h2">
                    <ScrollItem>
                        <div className="Utility__h2__img">
                            <picture>
                                <source type="image/webp" srcSet={RoadmapH2Webp} />
                                <img src={RoadmapH2} alt="Roadmap" />
                            </picture>
                        </div>
                    </ScrollItem>
                </h2>
                <ScrollItem>
                    <p className="Utility__description">Built to ignite your identity in the Web3 cosmos,
                        the BŌSŌ brand has you Metaverse ready.
                    </p>
                </ScrollItem>

                {/* Utility__container */}
                <div className="Utility__container">
                    <div className="Utility__card">
                        <div className="Utility__card__icon">
                            <ScrollItem>
                                <picture>
                                    <source type="image/webp" srcSet={RoadMapIconAvatarWebp} />
                                    <img src={RoadMapIconAvatar} alt="Utility" />
                                </picture>
                            </ScrollItem>
                        </div>
                        <div className="Utility__card__inner">
                            <ScrollItem>
                                <h3 className="Utility__card__h3">Limitless Commercial right to OUR IPS</h3>
                            </ScrollItem>
                            <ScrollItem>
                                <p className="Utility__card__text">
                                    You own the NFT, you own the IP rights. Simple as that.
                                </p>
                            </ScrollItem>
                        </div>
                    </div>
                    <div className="Utility__card">
                        <div className="Utility__card__icon">
                            <ScrollItem>
                                <picture>
                                    <source type="image/webp" srcSet={RoadMapIconAccessWebp} />
                                    <img src={RoadMapIconAccess} alt="Utility" />
                                </picture>
                            </ScrollItem>
                        </div>
                        <div className="Utility__card__inner">
                            <ScrollItem>
                                <h3 className="Utility__card__h3">METAVERSE AVATAR</h3>
                            </ScrollItem>
                            <ScrollItem>
                                <p className="Utility__card__text">
                                    The BŌSŌ vision is to provide holders with an identity defining avatar in the digital
                                    ecosystem. Are you Metaverse ready?
                                </p>
                            </ScrollItem>
                        </div>
                    </div>
                    <div className="Utility__card">
                        <div className="Utility__card__icon">
                            <ScrollItem>
                                <picture>
                                    <source type="image/webp" srcSet={RoadMapIconMetaverseWebp} />
                                    <img src={RoadMapIconMetaverse} alt="Utility" />
                                </picture>
                            </ScrollItem>
                        </div>
                        <div className="Utility__card__inner">
                            <ScrollItem>
                                <h3 className="Utility__card__h3">EXCLUSIVE ACCESS</h3>
                            </ScrollItem>
                            <ScrollItem>
                                <p className="Utility__card__text">
                                    Your NFT grants access to the BŌSŌ experience.
                                    Access to our private discord, events, and more.
                                </p>
                            </ScrollItem>
                        </div>
                    </div>
                    <div className="Utility__card">
                        <div className="Utility__card__icon">
                            <ScrollItem>
                                <picture>
                                    <source type="image/webp" srcSet={RoadMapIconCollabsWebp} />
                                    <img src={RoadMapIconCollabs} alt="Utility" />
                                </picture>
                            </ScrollItem>
                        </div>
                        <div className="Utility__card__inner">
                            <ScrollItem>
                                <h3 className="Utility__card__h3">COLLABS AND MERCH</h3>
                            </ScrollItem>
                            <ScrollItem>
                                <p className="Utility__card__text">
                                    Upcoming project NFTs, collabs, and merch available exclusively to the BŌSŌ holders.
                                </p>
                            </ScrollItem>
                        </div>
                    </div>
                    <div className="Utility__card--revving">
                        <div className="Utility__card">
                            <div className="Utility__card__icon">
                                <ScrollItem>
                                    <picture>
                                        <source type="image/webp" srcSet={RoadMapIconStakingWebp} />
                                        <img src={RoadMapIconStaking} alt="Utility" />
                                    </picture>
                                </ScrollItem>
                            </div>
                            <div className="Utility__card__inner">
                                <ScrollItem>
                                    <h3 className="Utility__card__h3">Revving (is to Stake)</h3>
                                </ScrollItem>
                                <ScrollItem>
                                    <p className="Utility__card__text">
                                        Rev your engine. Rev your BŌSŌ NFTs.<br />
                                        Revving increases RPM. Accumulating RPM unlocks rewards.<br />
                                        Rate of accumulation varies depending on your NFT type.
                                    </p>
                                </ScrollItem>
                            </div>

                        </div>
                        <div className="Utility__card__revvingImg">
                            {/* <ScrollItem> */}
                            <picture>
                                <source type="image/webp" srcSet={RoadmapRevvingImgWebp} />
                                <img src={RoadmapRevvingImg} alt="Revving image" />
                            </picture>
                            {/* </ScrollItem> */}
                        </div>
                    </div>
                </div>

                {/* YAO */}
                <div className="Utility__aid100">
                    <h3 className="Utility__aid100__h3">
                        <ScrollItem>
                            <picture>
                                <source type="image/webp" srcSet={YAOWebp} />
                                <img src={YAO} alt="YAO" />
                            </picture>
                        </ScrollItem>
                    </h3>
                    <ScrollItem>
                        <p className="Utility__aid100__description">The word “Yao” meaning “800” has always had an
                            important meaning in Japan. The Yaoyorozu God. Yao-ya. All these words have Yao in them and it
                            means there is a myriad of it.
                        </p>
                    </ScrollItem>
                    <ScrollItem>
                        <p className="Utility__aid100__description scrollItem">
                            The number 800 also consists of two “∞”. BŌSŌ TOKYO will create infinite possibilities together
                            with our BŌSŌ TOKYO holders to send out diverse talent from around the globe.
                        </p>
                    </ScrollItem>
                    <div className="Utility__aid100__img">
                        <ScrollItem>
                            <picture>
                                <source type="image/webp" srcSet={YAOImageWebp} />
                                <img src={YAOImage} alt="YAO image" />
                            </picture>
                        </ScrollItem>
                    </div>
                </div>

                {/* BŌSŌ Anthem */}
                <div className="Member__profileContainer">
                    <ScrollItem>
                        <h3 className="Member__profileTitle">BŌSŌ Anthem</h3>
                    </ScrollItem>
                    <div className="Member__profile">
                        <div className="Member__profile__icon--pc">
                            <ScrollItem>
                                <picture>
                                    <source type="image/webp" srcSet={AKLOWebp} />
                                    <img src={AKLO} alt="AKLO icon" />
                                </picture>
                            </ScrollItem>
                        </div>

                        <div>
                            <div className="Member__profile__spContainer">
                                <div className="Member__profile__icon--sp">
                                    <ScrollItem>
                                        <picture>
                                            <source type="image/webp" srcSet={AKLOWebp} />
                                            <img src={AKLO} alt="AKLO icon" />
                                        </picture>
                                    </ScrollItem>
                                </div>
                                <div className="Member__profile__rightContainer">
                                    <ScrollItem>
                                        <h3 className="Member__profile__h3">AKLO</h3>
                                    </ScrollItem>
                                    <ScrollItem>
                                        <p className="Member__profile__job">Rapper</p>
                                    </ScrollItem>
                                </div>
                            </div>

                            <div className='Member__profile__descriptionContainer'>
                                <ScrollItem>
                                    <p className="Member__profile__description">
                                        In 2012, his debut album "THE PACKAGE" debuted at #1 on iTunes charts.<br />
                                        The album was selected
                                        as one of the "Best New Artists" on iTunes that year, and their single "Red Pill" was
                                        nominated for the MTV VMAJ.
                                    </p>
                                </ScrollItem>
                                <ScrollItem>
                                    <p className="Member__profile__description">
                                        In 2014, he released his second album, "The Arrival”. In the
                                        “iTunes Best of 2014 Award” his album won the “Best Album of the Year” in the
                                        Hip-Hop/Rap
                                        category.
                                    </p>
                                </ScrollItem>
                                <ScrollItem>
                                    <p className="Member__profile__description">
                                        The single "RGTO" has accumulated over 20 million views on YouTube, was nominated
                                        for both MTV VMAJ and SSTV MVA, and has become AKLO’s most well-known song.
                                    </p>
                                </ScrollItem>
                                <ScrollItem>
                                    <p className="Member__profile__description">
                                        Recently, his song has been selected as TV drama ending songs and frequently appears on
                                        TV himself as well.
                                        He featured in ALI's song "Lost in Paradise feat. AKLO," which was then used by Shohei
                                        Otani as his entrance song.
                                    </p>
                                </ScrollItem>
                            </div>
                        </div>
                    </div>
                    <div className="Member__profile">
                        <div className="Member__profile__icon--pc">
                            <ScrollItem>
                                <picture>
                                    <source type="image/webp" srcSet={TRILLWebp} />
                                    <img src={TRILL} alt="TRILL icon" />
                                </picture>
                            </ScrollItem>
                        </div>

                        <div>
                            <div className="Member__profile__spContainer">
                                <div className="Member__profile__icon--sp">
                                    <ScrollItem>
                                        <picture>
                                            <source type="image/webp" srcSet={TRILLWebp} />
                                            <img src={TRILL} alt="TRILL icon" />
                                        </picture>
                                    </ScrollItem>
                                </div>
                                <div className="Member__profile__rightContainer">
                                    <ScrollItem>
                                        <h3 className="Member__profile__h3">TRILL DYNASTY</h3>
                                    </ScrollItem>
                                    <ScrollItem>
                                        <p className="Member__profile__job">Composer</p>
                                    </ScrollItem>
                                </div>
                            </div>

                            <div className="Member__profile__descriptionContainer">
                                <ScrollItem>
                                    <p className="Member__profile__description">
                                        TRILL DYNASTY started his career in 2015 as a DJ, but soon started composing tracks.<br />
                                        In 2021, he produced the title track for Chicago artist Lil Durk's album "The Voice,"
                                        which debuted at #1 on Billboard’s Hip Hop/R&B charts on January that year..
                                    </p>
                                </ScrollItem>
                                <ScrollItem>
                                    <p className="Member__profile__description">
                                        In August of the same year, he produced the song "In Town (feat. Lil Durk)" for EST
                                        Gee's album "Bigger Than Life Of Death". This went on to reach No. 5 on Billboard’s Hip Hop/R&B charts as well.
                                    </p>
                                </ScrollItem>
                                <ScrollItem>
                                    <p className="Member__profile__description">
                                        He is also active in the Japanese music scene, producing songs for BAD HOP and ¥ellow
                                        Bucks.<br />
                                        He specializes in songs with distinctive piano tones, and it is no exaggeration to say
                                        that
                                        he is one of the most popular loop makers in Japan today.
                                    </p>
                                    <br />
                                </ScrollItem>
                                <ScrollItem>
                                    <p className="Member__profile__description">
                                        -Music Credits US:Lil Durk, OMB
                                        Peezy, Jackboy, Fredo Bang, EST Gee, RJAE, Kiddo Marv, Teejay3k, Major Nine, Young
                                        ChopJPN:BADHOP, ¥ellow Bucks, CzTIGER, Lunv Loyal, JP The Wavy, TOFU, SALU, Kowichi,
                                        ELIONE
                                    </p>
                                </ScrollItem>
                            </div>
                        </div>
                    </div>
                </div>

                {/* decoration */}
                <SectionDecoration />
            </div>
        </section>

    )
}